import { getTrackingKey } from '@/utils/api'

import API from './base'

class CheckoutSessionAPI extends API {
  checkSession = (checkoutId) => {
    return this.fetcher(
      {
        method: 'GET',
        trackingKey: getTrackingKey(this.uri, 'session_CHECKOUT-ID'),
        path: this.uri + `/session/${checkoutId}`,
      },
      {
        options: {
          attachToken: false,
        },
      }
    )
  }

  cancelCheckoutSession = (checkoutId) => {
    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'CHECKOUT-ID_cancel'),
      path: this.uri + `/${checkoutId}/cancel`,
    })
  }
}

export default new CheckoutSessionAPI('/checkout')
